/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListDeviceIntegrationProvidersSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListDeviceIntegrationProvidersRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListDeviceIntegrationProvidersSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListDeviceIntegrationProvidersSecurity$outboundSchema:
  z.ZodMiniType<
    ListDeviceIntegrationProvidersSecurity$Outbound,
    ListDeviceIntegrationProvidersSecurity
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.optional(z.string()),
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listDeviceIntegrationProvidersSecurityToJSON(
  listDeviceIntegrationProvidersSecurity:
    ListDeviceIntegrationProvidersSecurity,
): string {
  return JSON.stringify(
    ListDeviceIntegrationProvidersSecurity$outboundSchema.parse(
      listDeviceIntegrationProvidersSecurity,
    ),
  );
}

/** @internal */
export type ListDeviceIntegrationProvidersRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListDeviceIntegrationProvidersRequest$outboundSchema:
  z.ZodMiniType<
    ListDeviceIntegrationProvidersRequest$Outbound,
    ListDeviceIntegrationProvidersRequest
  > = z.pipe(
    z.object({
      gramKey: z.optional(z.string()),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramKey: "Gram-Key",
        gramSession: "Gram-Session",
      });
    }),
  );

export function listDeviceIntegrationProvidersRequestToJSON(
  listDeviceIntegrationProvidersRequest: ListDeviceIntegrationProvidersRequest,
): string {
  return JSON.stringify(
    ListDeviceIntegrationProvidersRequest$outboundSchema.parse(
      listDeviceIntegrationProvidersRequest,
    ),
  );
}
